module.exports = __webpack_public_path__ + "static/lord-of-the-world-dcac45be43be97d23b5bf959dfde40c2.jpg";